import { createComponent } from '@lit-labs/react';
import React from 'react';

export class SelectedButtonDS2 extends HTMLElement {
  secondary?: boolean;
  value: unknown;
  constructor() {
    super();
  }
}

export const SelectedButton2 = createComponent(React, 'btn', SelectedButtonDS2, {
  onSelectedChange: 'selected-changed',
});
